import React, { useState, useEffect } from 'react';
import { Search, Command } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { GlobalSearchDialog } from './GlobalSearchDialog';

export const GlobalSearchTrigger: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className="hidden md:flex items-center gap-3 px-4 py-2 h-10 bg-muted/50 hover:bg-muted border-border/50 text-muted-foreground hover:text-foreground transition-all duration-200 rounded-xl min-w-[240px]"
      >
        <Search className="h-4 w-4" />
        <span className="text-sm">Buscar...</span>
        <div className="flex-1" />
        <kbd className="flex items-center gap-0.5 px-2 py-1 text-xs bg-background border border-border rounded-md font-mono">
          <Command className="h-3 w-3" />
          <span>K</span>
        </kbd>
      </Button>

      {/* Mobile trigger */}
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setOpen(true)}
        className="md:hidden"
        aria-label="Buscar"
      >
        <Search className="h-5 w-5" />
      </Button>

      <GlobalSearchDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
